import React from "react";
import productService from "../services/productService";
import { showProcess, hideProcess, getFileServer, UserSession, getUrlApi } from "../utils/util";
import { Galleria } from "primereact/galleria";
import shoppingCartService from "../services/shoppingCartService";
import bannersService from "../services/bannersService";
import { Paginator } from "primereact/paginator";

export default class HowItWorks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    componentDidMount() {
        
    }

    render() {
       return (
            <>
                <img src={require("../img/como funciona.png")} alt="Como Funciona" style={{width: "100%", height: "auto"}}/>
                   

                <div style={{width: "100%", textAlign: "center", marginTop: "50px", marginBottom: "100px"}}>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "43px", fontWeight: "600"}}>
                        Pronto para resgatar?
                    </label>
                    <br/>
                    <br/>
                    <br/>
                    <button onClick={() => window.location.href = "https://api.whatsapp.com/send/?phone=5511942505855&text=Ol%C3%A1%2C+gostaria+de++saber+mais+sobre+a+BHN&type=phone_number&app_absent=0"}
                            style={{backgroundColor: "var(--unnamed-color-411172)", color: "#fff", border: "none", borderRadius: "50px", padding: "20px 80px", fontSize: "30px", cursor: "pointer", fontWeight: "600"}}>
                                Resgatar meus créditos
                    </button>
                    <br/>
                    <br/>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "14px", fontWeight: "400"}}>
                        Ficou com dúvidas? Acesse a 
                        <a href="https://www.omelhorpresentepara.com.br/ContactUs" target="_blank" style={{fontWeight: "600", marginLeft: "5px"}}>
                            Central de ajuda
                        </a>
                    </label>
                </div>
            </>
        );
    }
}
